import core from "@/helpers/client";
const restService = {
  async headPermissionAsync(applicationId,params) {
    const result = await core.head(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/permissions?no-cache=1`,
      params
    );
    return result;
  },
  async getPermissionsAsync(applicationId,params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/permissions?no-cache=1`,
      params
    );
    return result;
  },
  async getPermissionAsync(applicationId,id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/permissions/${id}?no-cache=1`
    );
    return result;
  },
  async createPermissionAsync(applicationId,model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/permissions`,
      model
    );
    return result;
  },
  async bulkPermissionAsync(applicationId,model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/Applications/${applicationId}/Permissions/swaggers`,
      model
    );
    return result;
  },
  async updatePermissionAsync(applicationId,id, model) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/permissions/${id}`,
      model
    );
    return result;
  },
  async deletePermissionMasterByIdAsync(applicationId,id) {
    const result = await core.delete(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/permissions/${id}`
    );
    return result;
  },
};
export default restService;
